import {
    CARD_GROUP_SIZE,
    CARD_HOLDER_MAX_LENGTH,
    CARD_NUMBER_LENGTH,
    CVC_MAX_LENGTH,
    CVC_MIN_LENGTH,
    EXPIRY_MAX_YEARS_AHEAD,
} from '../../../core/constants/payment';

// Formatting and shape validation for the simulated card form. Nothing here
// talks to a gateway — the checkout only needs the inputs to look plausible.

function digitsOnly(value) {
    return String(value ?? '').replace(/\D/g, '');
}

export function normalizeCardNumber(value) {
    return digitsOnly(value).slice(0, CARD_NUMBER_LENGTH);
}

export function formatCardNumber(value) {
    return normalizeCardNumber(value).replace(new RegExp(`(.{${CARD_GROUP_SIZE}})`, 'g'), '$1 ').trim();
}

export function normalizeExpiry(value) {
    return digitsOnly(value).slice(0, 4);
}

export function formatExpiry(value) {
    const digits = normalizeExpiry(value);
    if (digits.length <= 2) return digits;
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
}

export function normalizeCvc(value) {
    return digitsOnly(value).slice(0, CVC_MAX_LENGTH);
}

export function normalizeHolder(value) {
    return String(value ?? '')
        .replace(/[^\p{L}\s.'-]/gu, '')
        .slice(0, CARD_HOLDER_MAX_LENGTH)
        .toUpperCase();
}

function isExpiryValid(value, now) {
    const digits = normalizeExpiry(value);
    if (digits.length !== 4) return false;

    const month = Number(digits.slice(0, 2));
    if (month < 1 || month > 12) return false;

    const year = 2000 + Number(digits.slice(2));
    const currentYear = now.getFullYear();
    if (year < currentYear || year > currentYear + EXPIRY_MAX_YEARS_AHEAD) return false;
    if (year === currentYear && month < now.getMonth() + 1) return false;

    return true;
}

// `now` is injected so the rule stays pure and testable.
export function validatePayment(form, now = new Date()) {
    const errors = {};

    if (normalizeHolder(form.holder).trim().length < 3) {
        errors.holder = 'Escribe el nombre como aparece en la tarjeta';
    }
    if (normalizeCardNumber(form.number).length !== CARD_NUMBER_LENGTH) {
        errors.number = `El número debe tener ${CARD_NUMBER_LENGTH} dígitos`;
    }
    if (!isExpiryValid(form.expiry, now)) {
        errors.expiry = 'Vencimiento inválido (MM/AA)';
    }
    if (normalizeCvc(form.cvc).length < CVC_MIN_LENGTH) {
        errors.cvc = `El CVC debe tener al menos ${CVC_MIN_LENGTH} dígitos`;
    }

    return { errors, isValid: Object.keys(errors).length === 0 };
}

export function maskCardNumber(value) {
    const digits = normalizeCardNumber(value);
    return `•••• ${digits.slice(-CARD_GROUP_SIZE)}`;
}
